<div class="content">
  <mat-tab-group mat-align-tabs="center" [selectedIndex]="data?.selectedTabIndex">
    <mat-tab label="{{tabLabel}}" *ngIf="data.type === 'position'">
      <app-position-details
        [levels]="levels"
        [group]="group"
        [position]="position"
        [pallets]="pallets"
        [occupationList]="occupationList"
        (closeStockLevelsModal)="handleCloseModalEvent($event)"
        (changeToEditLevel)="onChangeToEditLevel($event)"
        (onInventoryClick)="handleInventoryClick($event)">
      </app-position-details>
    </mat-tab>
    <mat-tab label="{{tabLabel}}" *ngIf="data.type !== 'position' ">
      <app-row-column-details
        [occupationList]="occupationList"
        [pallets]="pallets"
        [coords]="rowColumnCoords"
        [positions]="rowColumnPositions"
        >
      </app-row-column-details>
    </mat-tab>
    <mat-tab label="Pallets ({{pallets.length}})">
      <app-crate-list-details
        [pallets]="pallets"
        [palletToScrollTo]="data?.scrollTo"
        (palletDetailsClicked)="onPalletDetailsClicked($event)"
        (historyClicked)="onHistoryClicked($event)"
        (commentsClicked)="onCommentsClicked($event)"
        (inventoryClicked)="onInventoryClickedFromList($event)"
        (relocateClicked)="onRelocateClickedFromList($event)">
      </app-crate-list-details>
    </mat-tab>
  </mat-tab-group>
</div>
